import { useState, useCallback } from 'react';
import { TableUser, UserToEdit } from '../Pages/Users/types';
import { AddUserFormValues } from '../Components/UserForm/types';

const useUserModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userToEdit, setUserToEdit] = useState<UserToEdit | null>(null);

  const openModalForEdit = useCallback((user: TableUser) => {
    setUserToEdit(user as unknown as UserToEdit);
    setIsModalOpen(true);
  }, []);

  const openModalForAdd = useCallback(() => {
    setUserToEdit(null);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setUserToEdit(null);
  }, []);

  const handleSubmitForm = useCallback(
    (values: AddUserFormValues) => {
      closeModal();
    },
    [closeModal]
  );

  return {
    isModalOpen,
    userToEdit,
    openModalForEdit,
    openModalForAdd,
    closeModal,
    handleSubmitForm,
  };
};

export default useUserModal;
